export const ObservacoesIcon = () => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="4"
      y="4"
      width="48"
      height="48"
      rx="24"
      fill="#2D5BFF"
      fillOpacity="0.4"
    />
    <rect
      x="4"
      y="4"
      width="48"
      height="48"
      rx="24"
      stroke="#D5DEFF"
      strokeWidth="8"
    />
    <path
      d="M33.5 21.5L35 23L27 31H25.5V29.5L33.5 21.5Z"
      stroke="#2D5BFF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22 35H34"
      stroke="#2D5BFF"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
